/* eslint-disable import/first */
import React from 'react'
import ReactDOM from 'react-dom'
import './Firebase'
import { registerAuthListener } from 'registerListeners'
import registerServiceWorker from './registerServiceWorker'
import store from './store'
import App from './App'
import 'styles/core.css'

if (__DEV__) {
  if (window.devToolsExtension) {
    window.devToolsExtension.open()
  }
}
registerAuthListener(store)
ReactDOM.render(<App store={store} />, document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js